export default __webpack_public_path__ + "maps-examples-custom-callout-1200-b74fd1672351f3b5595c63262a0a66f9.webp";